<!--
 * @Author: your name
 * @Date: 2021-07-22 17:23:24
 * @LastEditTime: 2021-07-28 15:03:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-setting\indexes\inquiry\components\inquiryOp.vue
-->
<template>
  <div class="app-container">
    <el-form ref="form" :model="form" :rules="rules" inline label-width="140px">
      <el-form-item :label="$t('SearchConfiguration.Code')" prop="configCode">
        <BjInput v-model="form.configCode" :maxlength="MAX_LENGTH.DEFAULT" placeholder="" />
      </el-form-item>
      <el-form-item :label="$t('SearchConfiguration.Index')" prop="indexCode">
        <bj-code-select v-model="form.indexCode" @change="changeIndexCode" />
      </el-form-item>
      <el-form-item :label="$t('table.statusText')" prop="enabledFlag">
        <el-switch v-model="form.enabledFlag" :active-value="1" :inactive-value="0" />
      </el-form-item>
      <el-form-item :label="$t('SearchConfiguration.Description')" prop="remark">
        <BjInput v-model="form.remark" :maxlength="MAX_LENGTH.DEFAULT" placeholder="" />
      </el-form-item>
      <el-form-item :label="$t('SearchConfiguration.start')" prop="activeStartTime">
        <BjDateTimerPicker v-model="form.activeStartTime" />
      </el-form-item>
      <el-form-item :label="$t('SearchConfiguration.end')" prop="activeEndTime">
        <BjDateTimerPicker v-model="form.activeEndTime" />
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName">
      <el-tab-pane :label="$t('SearchConfiguration.add.Query')" name="1">
        <el-tabs tab-position="left" type="border-card">
          <el-tab-pane :label="$t('SearchConfiguration.add.Custom')">
            <el-row>
              <el-col :span="10">
                <vue-json-editor
                  v-model="resultInfo"
                  :show-btns="false"
                  :mode="'code'"
                  lang="zh"
                  @json-change="onJsonChange"
                  @json-save="onJsonSave"
                  @has-error="onError"
                />
                <div style="text-align: center">
                  <el-button type="primary" class="mt20" @click="submitJson">{{ $t('saveText') }}</el-button>
                </div>
              </el-col>
              <el-col :span="10" :offset="4">
                <vue-json-editor
                  v-model="resultInfo"
                  :show-btns="false"
                  :mode="'code'"
                  lang="zh"
                  class="read-only"
                  :class="resultInfo ? '' : 'hide_json'"
                />
                <div style="text-align: center">
                  <el-button type="primary" class="mt20" @click="onTest">{{ $t('SearchConfiguration.add.Test') }}</el-button>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('SearchConfiguration.add.Test')"
      :visible.sync="dialogVisible"
      width="420px"
    >
      <el-form label-width="104px">
        <el-form-item v-for="item in formList" :key="item" :label="item" inline>
          <BjInput
            v-model="testForm[item]"
            :maxlength="MAX_LENGTH.DEFAULT"
            :placeholder="$t('SearchConfiguration.add.enter') + item"
          />
        </el-form-item>
        <el-form-item :label="$t('SearchConfiguration.add.Return')">
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="onExecute()">{{ $t('SearchConfiguration.add.Execute') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { settingApi } from '@/api';
// import condition from './condition.vue';
import vueJsonEditor from 'vue-json-editor';
import BjCodeSelect from '../../components/BjCodeSelect';
// import fieldList from './fieldList';
export default {
  components: {
    // condition,
    vueJsonEditor,
    BjCodeSelect,
    // fieldList,
  },
  data() {
    return {
      form: {},
      rules: {
        configCode: [{ required: true, message: this.$t('SearchConfiguration.add.entercode'), trigger: 'blur' }],
        indexCode: [{ required: true, message: this.$t('SearchConfiguration.add.enterindex'), trigger: 'change' }],
        activeStartTime: [{ required: true, message: this.$t('SearchConfiguration.add.enterstart'), trigger: 'change' }],
        activeEndTime: [{ required: true, message: this.$t('SearchConfiguration.add.enterend'), trigger: 'change' }],
      },
      activeName: '1',
      resultInfo: null,
      hasJsonFlag: true,
      edit: false,

      fieldList: [],
      dialogVisible: false,
      formList: [],
      testForm: null,
    };
  },
  created() {
    if (this.$route.query.form) {
      this.form = JSON.parse(this.$route.query.form);
      this.form.queryJson = JSON.parse(this.form.queryJson);
      this.resultInfo = this.form.queryJson;
      this.edit = true;
      settingApi
        .getInquiryFieldList({ indexCode: this.form.indexCode, enabledFlag: this.form.enabledFlag })
        .then(res => {
          this.fieldList.push(res);
        });
    }
  },
  methods: {
    changeIndexCode(data) {
      this.form.indexCode = data.indexCode;
      this.form.indexId = data.indexId;
    },
    addInquire() {},
    onJsonChange(value) {
      this.hasJsonFlag = true;
      this.resultInfo = this.form.queryJson;
    },
    onJsonSave(value) {},
    onError(value) {
      this.hasJsonFlag = false;
    },
    submitJson() {
      this.$refs['form'].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        if (this.hasJsonFlag) {
          this.form.queryJson = JSON.stringify(this.resultInfo);
          if (this.edit) {
            settingApi.editInquiry(this.form).then(res => {
              if (!res.failed) {
                this.msgSuccess(this.$t('SearchConfiguration.add.successfully'));
                this.$router.back(-1);
              }
            });
          } else {
            settingApi.addInquiry(this.form).then(res => {
              if (!res.failed) {
                this.msgSuccess(this.$t('SearchConfiguration.add.added'));
                this.form = {};
                this.$router.back(-1);
              }
            });
          }
        } else {
          this.$alert(this.$t('SearchConfiguration.add.enterJSON'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            callback: action => {},
          });
        }
      });
    },
    /** 测试 */
    onTest() {
      this.formList = this.getExecData(JSON.stringify(this.resultInfo));
      this.dialogVisible = true;
    },
    /** 执行 */
    onExecute() {
      const obj = { configCode: this.form.configCode, queryMap: this.testForm };
      settingApi.InquiryFieldQuery(obj).then(res => {
      });
    },
    /** 收集字段 */
    getExecData(str) {
      const reg = /\#\{(.+?)\}/g;
      const list = [];
      let result = null;
      do {
        result = reg.exec(str);
        result && list.push(result[1]);
      } while (result);
      return list;
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
    },
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep .jsoneditor-menu {
  display: none;
}
::v-deep .read-only .ace_text-input {
  display: none;
}
::v-deep .read-only .ace-jsoneditor .ace_marker-layer .ace_active-line {
  background: none;
}
::v-deep .hide_json .ace_scroller {
  display: none;
}
::v-deep .read-only .ace_gutter-active-line {
  background: none;
}
pre {
  display: block;
  white-space: pre;
}
</style>
